"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignalStrength = SignalStrength;
var _react = _interopRequireDefault(require("react"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SignalStrength = require("./SignalStrength.styled");
var _SignalIcon = _interopRequireDefault(require("./SignalIcon"));
var tooltipTextMap = {
  poor: 'Poor connection',
  good: 'Good connection',
  excellent: 'Excellent connection'
};
function SignalStrength(_ref) {
  var attendeeId = _ref.attendeeId,
    networkQuality = _ref.networkQuality,
    latency = _ref.latency,
    packetLoss = _ref.packetLoss,
    jitter = _ref.jitter,
    videoSent = _ref.videoSent,
    videoReceived = _ref.videoReceived,
    _ref$showTextLabel = _ref.showTextLabel,
    showTextLabel = _ref$showTextLabel === void 0 ? false : _ref$showTextLabel,
    _ref$isLightTheme = _ref.isLightTheme,
    isLightTheme = _ref$isLightTheme === void 0 ? false : _ref$isLightTheme,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? null : _ref$width,
    mode = _ref.mode;
  var health = networkQuality;
  var toolTipId = "network-info-".concat(attendeeId);
  var tooltipText = tooltipTextMap[health] || 'No network data';
  var inlineTooltipText = tooltipText;
  if (width && width <= 1068) {
    inlineTooltipText = inlineTooltipText.replace('connection', '').trim();
  }
  return _react["default"].createElement(_SignalStrength.IconsWrapper, null, _react["default"].createElement(_SignalStrength.IconTextWrapper, null, _react["default"].createElement(_SignalIcon["default"], {
    toolTipId: toolTipId,
    health: health,
    isLightTheme: isLightTheme,
    attendeeId: attendeeId
  }), showTextLabel && _react["default"].createElement(_SignalStrength.NetworkLabel, null, inlineTooltipText)), _react["default"].createElement(_SignalStrength.StyledToolTip, {
    delay: {
      show: 300,
      hide: 100
    },
    id: "tooltip_".concat(toolTipId),
    target: toolTipId,
    placement: 'top',
    modifiers: [{
      name: 'preventOverflow',
      options: {
        boundary: 'window'
      }
    }],
    mode: mode
  }, health === 'NA' && _react["default"].createElement(_SignalStrength.TooltipContent, {
    className: mode
  }, _react["default"].createElement(_SignalStrength.NetworkItem, {
    className: mode
  }, _react["default"].createElement("section", {
    className: "left"
  }, _react["default"].createElement(_SignalIcon["default"], {
    toolTipId: toolTipId,
    health: health,
    tooltipShown: true
  })), _react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, _react["default"].createElement("b", null, tooltipText))), _react["default"].createElement(_SignalStrength.NoConnectivityMetricsMsg, {
    className: mode
  }, _react["default"].createElement("section", {
    className: "left"
  }, "Turn on the camera to view network details."))), health !== 'NA' && _react["default"].createElement(_SignalStrength.TooltipContent, {
    className: mode
  }, _react["default"].createElement(_SignalStrength.NetworkItem, {
    className: mode
  }, _react["default"].createElement("section", {
    className: "left"
  }, _react["default"].createElement(_SignalIcon["default"], {
    toolTipId: toolTipId,
    health: health,
    tooltipShown: true
  })), _react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, tooltipText)), _react["default"].createElement(_SignalStrength.NetworkItem, {
    className: mode
  }, _react["default"].createElement("section", {
    className: "left"
  }, _react["default"].createElement(_SignalStrength.StyledNetworkIcon, {
    className: mode,
    icon: _freeSolidSvgIcons.faLinkSlash
  })), _react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, _react["default"].createElement("b", null, "Packet Loss:"), " ", packetLoss, "%")), _react["default"].createElement(_SignalStrength.NetworkItem, {
    className: mode
  }, _react["default"].createElement("section", {
    className: "left"
  }, _react["default"].createElement(_SignalStrength.StyledNetworkIcon, {
    className: mode,
    icon: _freeSolidSvgIcons.faWaveSquare
  })), _react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, _react["default"].createElement("b", null, "Jitter:"), " ", jitter, "ms")), _react["default"].createElement(_SignalStrength.NetworkItem, {
    className: mode
  }, _react["default"].createElement("section", {
    className: "left"
  }, _react["default"].createElement(_SignalStrength.StyledNetworkIcon, {
    className: mode,
    icon: _freeSolidSvgIcons.faStopwatch
  })), _react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, _react["default"].createElement("b", null, "Latency:"), " ", latency, "ms")), _react["default"].createElement(_SignalStrength.NetworkItem, null, _react["default"].createElement("section", {
    className: "left"
  }, _react["default"].createElement(_SignalStrength.StyledNetworkIcon, {
    className: mode,
    icon: _proSolidSvgIcons.faVideoArrowUpRight
  })), _react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, _react["default"].createElement("b", null, "Sending:"), " ", videoSent)), videoReceived && videoReceived !== 'NA' && _react["default"].createElement(_SignalStrength.NetworkItem, null, _react["default"].createElement("section", {
    className: "left"
  }, _react["default"].createElement(_SignalStrength.StyledNetworkIcon, {
    className: mode,
    icon: _proSolidSvgIcons.faVideoArrowDownLeft
  })), _react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, _react["default"].createElement("b", null, "Receiving:"), " ", videoReceived)))));
}
SignalStrength.propTypes = {
  attendeeId: _propTypes["default"].string.isRequired,
  networkQuality: _propTypes["default"].string,
  latency: _propTypes["default"].string,
  packetLoss: _propTypes["default"].string,
  jitter: _propTypes["default"].string,
  videoSent: _propTypes["default"].string,
  videoReceived: _propTypes["default"].string,
  showTextLabel: _propTypes["default"].bool,
  mode: _propTypes["default"].string,
  isLightTheme: _propTypes["default"].bool,
  width: _propTypes["default"].any
};